// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"038bb985","195":"f31c4b61","323":"574afe85","417":"47c00cb9","453":"abd36b29","553":"4c486ac7","714":"89eaef97"}[chunkId] + ".chunk.js";
};